import { classifyError } from 'src/modules/error-helper';
import type { ReduxInjections } from 'src/types';
import { GetScoreDocument } from 'src/types/graphql';

import { shouldUpdate } from '../../../middlewares/utils.ts';

import { updateTipsSuccess, updateTipsFailure } from './actionCreators';

export const makeTipsUpdater = ({
  api: { queryGql, apolloClient },
  appConfig,
}: ReduxInjections) => ({
  on: (type: string) => shouldUpdate(type, appConfig, apolloClient),
  run: () => {
    const { language: languageCode, zone, isUnifiedSite } = appConfig;
    return queryGql({
      query: GetScoreDocument,
      variables: {
        zone,
        languageCode,
        isUnifiedSite,
      },
      fetchPolicy: 'network-only',
    });
  },
  success: updateTipsSuccess,
  failure: updateTipsFailure,
  classifyError,
});
